module.exports = "<div class=\"character-filter\">\r\n  <span *ngFor=\"let letter of alphaNumeric\"\r\n        (click)=\"selectCharacter(letter)\"\r\n        [class.selected]=\"letter === selectedCharacter\">\r\n    {{ letter }}\r\n  </span>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/opc/opc-admin/partgroup/part-filter/part-filter.component.html
// module id = ./src/opc/opc-admin/partgroup/part-filter/part-filter.component.html
// module chunks = main